// extracted by mini-css-extract-plugin
module.exports = {"profile":"Profile_profile__CthWc","profile_information":"Profile_profile_information__2xSXH"};